import { Tabs, Tab, Card, CardBody } from "@nextui-org/react";
import Form from "./NewPaint";
import FileExcelUpload from "./Excel";
import UploadGroupImages from "./UploadGroupImages";

const AddPaint = () => {
    return (
        <>
            <div className="flex w-full flex-col">
                <Tabs aria-label="Options" className="border-b pb-3">
                    <Tab key="form" title="فرم">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Form />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="excel" title="اکسل">
                        <div className="text-rose-500 text-center">
                            * لطفا ابتدا فایل اکسل سپس تصاویر مربوطه را آپلود کنید در غیر اینصورت عکس ها با اکسل مطابقت داده نمیشود.
                        </div>
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Tabs aria-label="Options" className="border-b pb-3">
                                    <Tab key="file" title="فایل">
                                        <Card style={{ boxShadow: 'none' }}>
                                            <CardBody>
                                                <FileExcelUpload />
                                            </CardBody>
                                        </Card>
                                    </Tab>
                                    <Tab key="images" title="عکس ها">
                                        <Card style={{ boxShadow: 'none' }}>
                                            <CardBody>
                                                <UploadGroupImages />
                                            </CardBody>
                                        </Card>
                                    </Tab>
                                </Tabs>
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>

        </>
    );
};

export default AddPaint;